module.exports = __webpack_public_path__ + "static/farmers_schedule-8786b95a52000eed24bba0682a30de0b.png";